// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._F7U4LeMBwHxBje7ZOD6 {
  background: var(--grey-color-10);
  padding: 32px;
}

.alwMFdJvQw_ki4JqTUAy {
  position: absolute;
  top: 6px;
  left: 6px;
}

.HZLHckZkcEzD8O3DNt5F {
  margin-right: 4px;
}

.J8w2nQLuxRhh0yxdsRwB {
  background-color: var(--background-color);
  padding: 16px 32px;
  border-radius: 10px;
}

.LmrWV_3m3DLZujWad8F8 {
  width: 100%;
}

.fH0wo0h17eHVIjv26d3m {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  margin-bottom: 20px;
}

.JCsCQ6kpdswpdbY3Escu {
  display: flex;
  gap: 40px;
  background-color: var(--grey-color-10);
  margin: 16px 0;
  padding: 16px 0;
  border-radius: 10px;
}

.pATjgzgQhlMQMcijL3CN {
  flex: 3;
  background-color: var(--background-color);
  padding: 32px;
  border-radius: 10px;
}

.n5t97WBHKm66B4DEqJdj {
  margin-top: 100px;
}

.JZFnZWa3pF5WQJWi9SVQ {
  flex: 7;
  background-color: var(--background-color);
  padding: 32px;
  border-radius: 10px;
}

.iZgTe59a6MIYMV0K058E {
  flex: 3;
  background-color: var(--background-color);
  padding: 4px 32px 32px 32px;
  border-radius: 10px;
  width: 100%;
}

.NO3ehaJuyuaNU8ud5n8Y {
  margin-top: 32px;
}

.wmJqxrjfgOH8RasN7eJE {
  background-color: var(--background-color);
  margin-top: 32px;
  padding: 32px;
  border-radius: 10px;
}

.qPK9D9MeYvF3F9WXSEnS {
  font-family: var(--font-stack-full-medium);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
  display: flex;
  justify-content: space-between;
}

.hhaZhRU6ehgMnTfZ2esl {
  height: 1px;
  margin: 16px 0;
  background-color: var(--grey-color-200);
}

.VU2gyRK04QJrhgiD5eTY {
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr;
  margin-top: 24px;
  gap: 32px;
}

.klqEHdW7e01yI1CB7d8E, .VSA7KcYtqKmEqH8NvEi4 {
  font-family: var(--font-stack-full-medium);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
}

.T6y1ncQTn1txHQWO5sTa {
  display: flex;
  justify-content: space-between;
  margin-left: 5px;
}

.QkUi1W3WbKjCQ09KPyhN {
  display: flex;
  align-items: center;
}

.VSA7KcYtqKmEqH8NvEi4 {
  margin-left: 14px;
}

.lg3iPeuxcwK_JIwWWAnS {
  margin-top: 12px;
}

.irzYbcyKVgnpGlbzVsQB {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
}

.bMD3aRUPogc57bHJR7yi {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background-color: var(--grey-color-10);
  border-radius: 12px;
}

.tAc6X9DkkZEdlmRqI1lJ {
  font-family: var(--font-stack-full-regular);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--grey-color-90);
}

.nW1xX8CUzalvkaRg6i7u {
  color: var(--grey-color-90);
  background-color: #cccccc;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/CohortSkillGroup/CohortSkillGroup.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,sCAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,SAAA;AACF;;AAEA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,2BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,sCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,2BAAA;EACA,yBAAA;EACA,kBAAA;AAAF","sourcesContent":[".container {\n  background: var(--grey-color-10);\n  padding: 32px;\n}\n\n.barChartTitle {\n  position: absolute;\n  top: 6px;\n  left: 6px;\n}\n\n.projectName {\n  margin-right: 4px;\n}\n\n.levelledLegendContainer {\n  background-color: var(--background-color);\n  padding: 16px 32px;\n  border-radius: 10px;\n}\n\n.innerHeatmapContainer {\n  width: 100%;\n}\n\n.heatmapTitle {\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  margin-bottom: 20px;\n}\n\n.chartContainer {\n  display: flex;\n  gap: 40px;\n  background-color: var(--grey-color-10);\n  margin: 16px 0;\n  padding: 16px 0;\n  border-radius: 10px;\n}\n\n.piChartContainer {\n  flex: 3;\n  background-color: var(--background-color);\n  padding: 32px;\n  border-radius: 10px;\n}\n\n.donutChartInner {\n  margin-top: 100px;\n}\n\n.barChartContainer {\n  flex: 7;\n  background-color: var(--background-color);\n  padding: 32px;\n  border-radius: 10px;\n}\n\n.heatmapContainer {\n  flex: 3;\n  background-color: var(--background-color);\n  padding: 4px 32px 32px 32px;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.heatmap {\n  margin-top: 32px;\n}\n\n.scoringFactorContainer {\n  background-color: var(--background-color);\n  margin-top: 32px;\n  padding: 32px;\n  border-radius: 10px;\n}\n\n.scoringFactorTitle {\n  font-family: var(--font-stack-full-medium);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n  display: flex;\n  justify-content: space-between;\n}\n\n.scoringFactorDividerLine {\n  height: 1px;\n  margin: 16px 0;\n  background-color: var(--grey-color-200);\n}\n\n.averageDistributionTitleContainer {\n  display: grid;\n  grid-template-columns: 0.5fr 1fr 1fr;\n  margin-top: 24px;\n  gap: 32px;\n}\n\n.averageAndDistributionLabel {\n  font-family: var(--font-stack-full-medium);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.averageScoreAndArrowIconContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-left: 5px;\n}\n\n.arrowIconContainer {\n  display: flex;\n  align-items: center;\n}\n\n.distributionScoreTitle {\n  margin-left: 14px;\n  @extend .averageAndDistributionLabel;\n}\n\n.factorScoringMainContainer {\n  margin-top: 12px;\n}\n\n.targetText {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.targetErrorMessageContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px;\n  background-color: var(--grey-color-10);\n  border-radius: 12px;\n}\n\n.targetErrorMessage {\n  font-family: var(--font-stack-full-regular);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--grey-color-90);\n}\n\n.infoIconStyle {\n  color: var(--grey-color-90);\n  background-color: #cccccc;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_F7U4LeMBwHxBje7ZOD6`,
	"barChartTitle": `alwMFdJvQw_ki4JqTUAy`,
	"projectName": `HZLHckZkcEzD8O3DNt5F`,
	"levelledLegendContainer": `J8w2nQLuxRhh0yxdsRwB`,
	"innerHeatmapContainer": `LmrWV_3m3DLZujWad8F8`,
	"heatmapTitle": `fH0wo0h17eHVIjv26d3m`,
	"chartContainer": `JCsCQ6kpdswpdbY3Escu`,
	"piChartContainer": `pATjgzgQhlMQMcijL3CN`,
	"donutChartInner": `n5t97WBHKm66B4DEqJdj`,
	"barChartContainer": `JZFnZWa3pF5WQJWi9SVQ`,
	"heatmapContainer": `iZgTe59a6MIYMV0K058E`,
	"heatmap": `NO3ehaJuyuaNU8ud5n8Y`,
	"scoringFactorContainer": `wmJqxrjfgOH8RasN7eJE`,
	"scoringFactorTitle": `qPK9D9MeYvF3F9WXSEnS`,
	"scoringFactorDividerLine": `hhaZhRU6ehgMnTfZ2esl`,
	"averageDistributionTitleContainer": `VU2gyRK04QJrhgiD5eTY`,
	"averageAndDistributionLabel": `klqEHdW7e01yI1CB7d8E`,
	"distributionScoreTitle": `VSA7KcYtqKmEqH8NvEi4`,
	"averageScoreAndArrowIconContainer": `T6y1ncQTn1txHQWO5sTa`,
	"arrowIconContainer": `QkUi1W3WbKjCQ09KPyhN`,
	"factorScoringMainContainer": `lg3iPeuxcwK_JIwWWAnS`,
	"targetText": `irzYbcyKVgnpGlbzVsQB`,
	"targetErrorMessageContainer": `bMD3aRUPogc57bHJR7yi`,
	"targetErrorMessage": `tAc6X9DkkZEdlmRqI1lJ`,
	"infoIconStyle": `nW1xX8CUzalvkaRg6i7u`
};
export default ___CSS_LOADER_EXPORT___;
